import React, { useState, useEffect } from 'react';

import styles from './styles.pcss';
type Props = {
  messages: string[];
};
export default function (props: Props) {
  if (props.messages.length > 0) {
    return (
      <div>
        <hr className={styles.lineBreak} />
        <h1>Fix Transaction Job Results</h1>
        <ul className={styles.messageList}>
          {props.messages.map((msg: any, index: number) => (
            <li key={index} className={styles.message}>{msg}</li>
          ))}
        </ul>
      </div>
    );
  } else {
    return <></>;
  }
}
